import { render } from "./App.vue?vue&type=template&id=7cdeae6c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7cdeae6c&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/home_website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__